import React from "react";
import { CalendarIcon, ChartIcon, HistoryIcon, SparkIcon, TableIcon } from "./Icons";

const ICONS = [ChartIcon, TableIcon, CalendarIcon, HistoryIcon];

export default function Welcome({ name, userName, suggestions, onPick, compact }) {
  const hour = new Date().getHours();
  const greet = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
  const list = compact ? suggestions.slice(0, 4) : suggestions.slice(0, 8);
  return (
    <div className="bdai-welcome">
      <div className="bdai-welcome-logo"><SparkIcon size={26} /></div>
      <h2 className="bdai-welcome-title">
        {greet}
        {userName ? `, ${userName}` : ""}!
      </h2>
      <p className="bdai-welcome-sub">
        I'm your {name}. Ask anything about tenders, stage progress, team leads, EMD / BG and competitors.
        Pick a date range above to focus the report.
      </p>
      <div className={`bdai-suggest-grid ${compact ? "bdai-suggest-compact" : ""}`}>
        {list.map((s, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <button type="button" key={s} className="bdai-suggest" onClick={() => onPick(s)}>
              <Icon size={15} className="bdai-suggest-icon" />
              <span>{s}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
